export default "__VITE_ASSET__CIm3hYe5__"